export default __webpack_public_path__ + "static/media/grupodpg125.293801e0.svg";